<template>
  <svg
    width="123"
    height="82"
    viewBox="0 0 123 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.1048 80.8417C80.928 76.8236 87.513 61.8455 85.7122 35.1963C86.5129 1.21951 63.2208 0.0836438 46.3976 4.10175C29.5745 8.11986 -4.41348 27.0968 0.47622 48.2879C5.36592 69.4791 47.2817 84.8598 64.1048 80.8417ZM77.1237 32.7643L80.0178 21.7752L69.2167 24.7198L77.1237 32.7643ZM34.4115 67.1245L37.3057 56.1354L26.5045 59.0799L34.4115 67.1245ZM21.6443 27.2582L29.7077 29.4567L23.8049 35.4631L21.6443 27.2582Z"
      :fill="getColor('0.15')"
    />
    <path
      d="M36.062 38.7844L38.2148 42.5132H33.9092L36.062 38.7844Z"
      :fill="getColor('0.5')"
    />
    <path
      d="M63.3259 33.9533L68.2818 34.488L65.3408 38.5127L63.3259 33.9533Z"
      :fill="getColor('0.5')"
    />
    <path
      d="M60.5665 60.7075L58.6451 67.8784L53.3955 62.6289L60.5665 60.7075Z"
      :fill="getColor('0.5')"
    />
    <path
      d="M38.0268 13.5165L39.707 19.7871L33.4364 18.1069L38.0268 13.5165Z"
      :fill="getColor('0.5')"
    />
    <path
      d="M8.36272 43.5672L16.0903 40.3838L14.9835 48.6678L8.36272
        43.5672Z"
      :fill="getColor('0.5')"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M72.6066 58.7932C88.7094 58.7932 101.763 45.7394 101.763 29.6366C101.763 13.5339 88.7094 0.480011 72.6066 0.480011C56.5039 0.480011 43.45 13.5339 43.45 29.6366C43.45 45.7394 56.5039 58.7932 72.6066 58.7932ZM73.0846 50.1896C84.6997 50.1896 94.1156 40.7737 94.1156 29.1586C94.1156 17.5435 84.6997 8.12763 73.0846 8.12763C61.4695 8.12763 52.0536 17.5435 52.0536 29.1586C52.0536 40.7737 61.4695 50.1896 73.0846 50.1896Z"
      :fill="primaryColor"
    />
    <rect
      x="90.2918"
      y="48.0145"
      width="7.64763"
      height="38.2382"
      transform="rotate(-45.6903 90.2918 48.0145)"
      :fill="primaryColor"
    />
  </svg>
</template>

<script lang="ts">
import Vue from "vue"
export default Vue.extend({
  name: "ConfettiSearch",
  data() {
    return {
      primaryColor: this.$vuetify.theme.themes.light.primary?.toString(),
    }
  },
  methods: {
    getColor(alphaString = "1"): string {
      if (!this.primaryColor) return ""

      let r = parseInt(this.primaryColor.slice(1, 3), 16),
        g = parseInt(this.primaryColor.slice(3, 5), 16),
        b = parseInt(this.primaryColor.slice(5, 7), 16)

      return "rgba(" + r + ", " + g + ", " + b + ", " + alphaString + ")"
    },
  },
})
</script>
